// src/context/PageMetadataContext.js
import React, { createContext, useState, useContext } from 'react';

const PageMetadataContext = createContext(null);

export const usePageMetadata = () => useContext(PageMetadataContext);

export const PageMetadataProvider = ({ children }) => {
  const [hasCustomMetadata, setHasCustomMetadata] = useState(false);

  const value = { hasCustomMetadata, setHasCustomMetadata };

  return <PageMetadataContext.Provider value={value}>{children}</PageMetadataContext.Provider>;
};
